module.exports = rewards;